<template>
    <div class="head_all">
      <div class="head_nei">
        <div class="head_q">
      <div class="head_logo"><img src="../assets/logo.jpg" alt="" class="logo"></div>

      <div class="head_menu">
            <el-menu :default-active="itemData.activeIndex" class="el-menu-demo" mode="horizontal" >

              <el-menu-item :index="item.headIndex" v-for="item in itemData.menuData">
                <router-link :to="item.headPath">
                  <li class="header_li">{{item.headText}}</li>
                </router-link></el-menu-item>


    </el-menu>

      </div>
        </div>
      <div class="head_sn">
        <div class="tbp">
          <img src="../assets/image/ss1.png"  alt="" class="zy" @click="choice()">
        </div>
        <div  class="tbp_1" v-show="showimg" v-for="item in itemData.language" @click="checkM(item.path)">{{item.text1}}</div>

      </div>
      </div>
  </div>

</template>
<script>
import {Data} from "./js/hearder";

export default {
  data() {
    return {
      showimg:false,

      activeIndex:1,
      dataAll: Data,
      itemData: {},
    }
  },
  name: "hearder",
  created() {
    let that = this;
    let urlData = that.$route.path;
    console.log(urlData);
    for(let item in that.itemData.menuData){
      let itemData =  that.itemData.menuData[item]
      if(urlData == itemData.headPath){
        that.activeIndex = itemData.headIndex;
      }
    }

  },
  mounted() {
    let that = this;

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        break;
      }
    }
  },
  methods: {
    choice() {
      let that = this;
      if (that.showimg) {
        that.showimg = false;
      } else {
        that.showimg = true;
      }
    },

    choiceEn() {
      let that = this;
      console.log(that.$parent.message)
      for(let index in that.dataAll){
        let itemData= that.dataAll[index];
        if(that.$parent.message == itemData.type){
          that.itemData = itemData;
          break;
        }
      }
    },
    checkM(path) {
      let that = this;

      let urlData = that.$route.path;
      let urlAll = window.location.href;
      let param = "";
      if(urlAll.indexOf("?") > 0){
        param = urlAll.substring(urlAll.indexOf("?"));
      }
      console.log(param);
      console.log(path);

      if ('zh' == path) {
        if(that.$parent.message == 'en') {
          console.log(urlData)
          console.log(urlData.length)

          this.$router.push({
            path: urlData+param,
            query: {
              _t: new Date().getTime() // 添加时间戳
            }
          });

        }
      } else {
        if(that.$parent.message == 'zh') {
          if (urlData == '/') {
            this.$router.push({
              path: '/',
              query: {
                _t: new Date().getTime() // 添加时间戳
              }
            });
          } else {
            this.$router.push({
              path: urlData+param,
              query: {
                _t: new Date().getTime() // 添加时间戳
              }
            });
          }
        }
      }
      that.$parent.message = path;
      that.showimg = false;
    }
  }
}
</script>
<style>
.tbp_1{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  height: 35px;
  width: 70px;
  cursor: pointer;
}
.header_li{
  font-family: SourceHanSansCN;
}
.tbp{
  display: flex;
  width: 70px;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.el-menu--horizontal>.el-menu-item.is-active{
  border-bottom: 2px solid #59b200 !important;
}
.logo{
  width: 100%;
  height: 100%;
}
.head_logo{
  width: 9.78%;
  aspect-ratio: 115/64;
}
.head_sn{
  display: block;
  align-items: center;
  justify-content: right;
  margin-right: 10px;
  z-index: 100;
}
.zy{
  width: 20px;
  height: 20px;
}
.head_all{
  width: 100%;
  display: flex;
  height: 70px;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
}
.head_q{
  display: flex;
  height: 100%;
  width: 100%;

}
.head_nei{
  width: 80%;
  height: 100%;
  display: flex;
  background-color: #FFFFFF;
  justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// src/components/hearder.vue